import { Component, Input } from '@angular/core';
import { CoreMenuItem } from '@core/models';

@Component({
  standalone: false,
  selector: '[core-menu-vertical-section]',
  templateUrl: './section.component.html'
})
export class CoreMenuVerticalSectionComponent {
  @Input()
  item: CoreMenuItem;
}
